import { connect } from 'react-redux'
import { bindActionCreators, Dispatch, Action as ReduxAction } from 'redux'
import { createStructuredSelector } from 'reselect'

import LoginRedirectSuccess from './LoginRedirectSuccess'

import { actionCreators } from '@/checkout-instore-legacy/vendor/actions'
import {
  vendorSelector,
  storeSelector,
} from '@/checkout-instore-legacy/vendor/selectors'
import { rehydratedSelector } from '@/checkout-instore-legacy/redux/persistor'

export const mapStateToPropsSelector = createStructuredSelector({
  store: storeSelector,
  vendor: vendorSelector,
  readyToLoad: rehydratedSelector,
})

const mapDispatchToProps = (dispatch: Dispatch<ReduxAction>) =>
  bindActionCreators(actionCreators, dispatch)

export default connect(
  mapStateToPropsSelector,
  mapDispatchToProps
)(LoginRedirectSuccess)
